/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createClone } from '../../factoriesAny.js';
export var cloneDependencies = {
  typedDependencies: typedDependencies,
  createClone: createClone
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesClone.generated.js
// module id = 1366
// module chunks = 0